
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AlertService} from "../_services/alert.service";
import {FreighterLoaderTariff} from "../_models/freighter-loader-tariff";
import {LoaderService} from "../_services/loader.service";
import {FreighterLoaderTariffService} from "../_services/freighter-loader-tariff.service";

@Component({
  selector: 'app-edit-loader-tariff',
  templateUrl: './edit-loader-tariff.component.html',
  styleUrls: ['./edit-loader-tariff.component.css']
})
export class EditLoaderTariffComponent implements OnInit {
  tariff = new FreighterLoaderTariff();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private loaderService: LoaderService,
    private freighterLoaderTariffService: FreighterLoaderTariffService
  ) { }

  ngOnInit() {
    this.route.params
      .subscribe(
        params => {
          this.loadTariff(+params['id']);
        },
        e => console.error(e)
      );
  }

  loadTariff(id: number) {
    this.loaderService.show();
    this.freighterLoaderTariffService
      .getTariff(id).pipe(
      finalize(() => this.loaderService.hide()))
      .subscribe(
        t => this.tariff = t,
        r => {
          if(r.status === 404)
            this.alertService.error('Тариф не найден', true);
        }
      );
  }

  submit() {
    this.loaderService.show();
    this.freighterLoaderTariffService
      .updateTariff(this.tariff).pipe(
      finalize(() => this.loaderService.hide()))
      .subscribe(
        () => {
          this.alertService.success('Тариф изменён', true);
          this.router.navigate(['/tariffs/loaders']);
        },
        () => {}
      )
  }

  onSubmit() {
    this.submit();
  }
}
